// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doclist {
   list-style: none;
   margin: 0;
   padding: 0;
}
.doclist li {
   align-items: center;
   border-top: 1px solid transparent;
   border-bottom: 1px solid #eaeaea;
   margin-top: -1px;
}
.doclist li.selected {
   background-color: rgba(0,178,201,0.05);
   border-color: rgba(26,89,118,0.1);
}
.file-icon img {
   display: block;
   margin: 8px;
   width: 32px;
   height: 32px;
   object-fit: contain;
}
.file-icon img.cover {
   object-fit: cover;
}
.file-filename {
   padding: 6px 0;
}
.file-filename a {
   cursor: pointer;
}
.file-name {
   align-items: center;
   display: inline-flex;
   max-width: 100%;
}
.file-name a, .file-name .name {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   max-width: 95%;
}
.file-name .link {
   fill: #FFA726;
   cursor: pointer;
   display: inline-block;
   margin-left: 8px;
   width: 16px;
   height: 16px;
   outline: none;
}
.file-upload {
    display: none;
    overflow: hidden;
    width: 0;
    height: 0;
}
.file-name input {
   border: 1px solid rgba(42, 180, 192, .5);
   border-radius: 2px;
   display: none;
   width: 100%;
   outline: none;
   margin-left: -5px;
   padding: 4px;
}
.file-version {
   border: 1px solid rgba(0, 0, 0, .2);
   border-radius: 2px;
   color: rgba(0, 0, 0, .5);
   font-size: 11px;
   height: 18px;
   margin-left: 5px;
   opacity: .7;
   padding: 1px 4px;
}
.selected .file-version {
   border-color: rgba(0, 0, 0, .4);
   color: #555;
}
.editing a, .editing .link {
    display: none;
}
.editing input {
    display: block;
}

.action-button {
   background-color: #fff;
   border: 1px solid #ccc;
   border-radius: 3px;
   cursor: pointer;
   display: none;
   font-size: 13px;
   line-height: 21px;
   outline: none;
   position: relative;
   margin-left: 10px;
   min-width: 50px;
   padding: 0 10px;
   text-align: center;
}
.file-delete { margin-right: 10px; }
.doclist li:hover .action-button {
   display: block;
}
.file-action {
   color: #aaa;
   height: 40px;
}
.doclist li:hover .file-action {
   color: inherit;
}
.mat-menu-item {
   min-width: 11em;
}
.file-desc, .file-path {
   color: #999;
   font-size: 13px;
}
.file-path {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.margin-top {
   margin-top: 4px;
}

.collapse {
   padding-left: 0;
   min-width: 0;
   width: 0;
}
.select-type {
   margin-top: 20px;
   width: 100%;
}
.item-path {
   color: #4b5049;
}

::ng-deep .mat-checkbox-inner-container {
   height: 15px !important;
   width: 15px !important;;
}

@media (min-width: 480px) {
   .list-container {
      max-width: 100%;
   }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
   .info {
      min-width: 225px;
      width: 225px;
   }
}
@media only screen and (min-width: 480px) and (max-width: 768px) {
   .info {
      padding-left: 0px;
      min-width: 195px;
      width: 195px;
   }
   .list-container {
      min-width: 768px;
      width: 768px;
   }
}
@media only screen and (max-width: 480px) {
   .info {
      padding-left: 0px;
      min-width: 165px;
      width: 165px;
   }
   .list-container {
      min-width: 480px;
      width: 480px;
   }
}

input:disabled {
   background: #fff;
}

.drag-over {
   background-color: rgba(0, 188, 212, .2);
   opacity: .5;
}

.loader-overlay {
   background-color: #fff;
   cursor: wait;
   position: absolute;
   left: 0;
   top: 0;
   right: 0;
   bottom: 0;
   z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/dropbox-list/dropbox-list.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;AACA;GACG,mBAAmB;GACnB,iCAAiC;GACjC,gCAAgC;GAChC,gBAAgB;AACnB;AACA;GACG,sCAAsC;GACtC,iCAAiC;AACpC;AACA;GACG,cAAc;GACd,WAAW;GACX,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,iBAAiB;AACpB;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;GACG,mBAAmB;GACnB,oBAAoB;GACpB,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;GACnB,cAAc;AACjB;AACA;GACG,aAAa;GACb,eAAe;GACf,qBAAqB;GACrB,gBAAgB;GAChB,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,SAAS;AACb;AACA;GACG,wCAAwC;GACxC,kBAAkB;GAClB,aAAa;GACb,WAAW;GACX,aAAa;GACb,iBAAiB;GACjB,YAAY;AACf;AACA;GACG,mCAAmC;GACnC,kBAAkB;GAClB,wBAAwB;GACxB,eAAe;GACf,YAAY;GACZ,gBAAgB;GAChB,WAAW;GACX,gBAAgB;AACnB;AACA;GACG,+BAA+B;GAC/B,WAAW;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;AAEA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,eAAe;GACf,iBAAiB;GACjB,aAAa;GACb,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,eAAe;GACf,kBAAkB;AACrB;AACA,eAAe,kBAAkB,EAAE;AACnC;GACG,cAAc;AACjB;AACA;GACG,WAAW;GACX,YAAY;AACf;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;AAClB;AACA;GACG,WAAW;GACX,eAAe;AAClB;AACA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;AACA;GACG,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,YAAY;GACZ,QAAQ;AACX;AACA;GACG,gBAAgB;GAChB,WAAW;AACd;AACA;GACG,cAAc;AACjB;;AAEA;GACG,uBAAuB;GACvB,sBAAsB;AACzB;;AAEA;GACG;MACG,eAAe;GAClB;AACH;AACA;GACG;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;AACA;GACG;MACG,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;GACf;GACA;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;AACA;GACG;MACG,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;GACf;GACA;MACG,gBAAgB;MAChB,YAAY;GACf;AACH;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,uCAAuC;GACvC,WAAW;AACd;;AAEA;GACG,sBAAsB;GACtB,YAAY;GACZ,kBAAkB;GAClB,OAAO;GACP,MAAM;GACN,QAAQ;GACR,SAAS;GACT,aAAa;AAChB","sourcesContent":[".doclist {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n.doclist li {\n   align-items: center;\n   border-top: 1px solid transparent;\n   border-bottom: 1px solid #eaeaea;\n   margin-top: -1px;\n}\n.doclist li.selected {\n   background-color: rgba(0,178,201,0.05);\n   border-color: rgba(26,89,118,0.1);\n}\n.file-icon img {\n   display: block;\n   margin: 8px;\n   width: 32px;\n   height: 32px;\n   object-fit: contain;\n}\n.file-icon img.cover {\n   object-fit: cover;\n}\n.file-filename {\n   padding: 6px 0;\n}\n.file-filename a {\n   cursor: pointer;\n}\n.file-name {\n   align-items: center;\n   display: inline-flex;\n   max-width: 100%;\n}\n.file-name a, .file-name .name {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   max-width: 95%;\n}\n.file-name .link {\n   fill: #FFA726;\n   cursor: pointer;\n   display: inline-block;\n   margin-left: 8px;\n   width: 16px;\n   height: 16px;\n   outline: none;\n}\n.file-upload {\n    display: none;\n    overflow: hidden;\n    width: 0;\n    height: 0;\n}\n.file-name input {\n   border: 1px solid rgba(42, 180, 192, .5);\n   border-radius: 2px;\n   display: none;\n   width: 100%;\n   outline: none;\n   margin-left: -5px;\n   padding: 4px;\n}\n.file-version {\n   border: 1px solid rgba(0, 0, 0, .2);\n   border-radius: 2px;\n   color: rgba(0, 0, 0, .5);\n   font-size: 11px;\n   height: 18px;\n   margin-left: 5px;\n   opacity: .7;\n   padding: 1px 4px;\n}\n.selected .file-version {\n   border-color: rgba(0, 0, 0, .4);\n   color: #555;\n}\n.editing a, .editing .link {\n    display: none;\n}\n.editing input {\n    display: block;\n}\n\n.action-button {\n   background-color: #fff;\n   border: 1px solid #ccc;\n   border-radius: 3px;\n   cursor: pointer;\n   display: none;\n   font-size: 13px;\n   line-height: 21px;\n   outline: none;\n   position: relative;\n   margin-left: 10px;\n   min-width: 50px;\n   padding: 0 10px;\n   text-align: center;\n}\n.file-delete { margin-right: 10px; }\n.doclist li:hover .action-button {\n   display: block;\n}\n.file-action {\n   color: #aaa;\n   height: 40px;\n}\n.doclist li:hover .file-action {\n   color: inherit;\n}\n.mat-menu-item {\n   min-width: 11em;\n}\n.file-desc, .file-path {\n   color: #999;\n   font-size: 13px;\n}\n.file-path {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n.margin-top {\n   margin-top: 4px;\n}\n\n.collapse {\n   padding-left: 0;\n   min-width: 0;\n   width: 0;\n}\n.select-type {\n   margin-top: 20px;\n   width: 100%;\n}\n.item-path {\n   color: #4b5049;\n}\n\n::ng-deep .mat-checkbox-inner-container {\n   height: 15px !important;\n   width: 15px !important;;\n}\n\n@media (min-width: 480px) {\n   .list-container {\n      max-width: 100%;\n   }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n   .info {\n      min-width: 225px;\n      width: 225px;\n   }\n}\n@media only screen and (min-width: 480px) and (max-width: 768px) {\n   .info {\n      padding-left: 0px;\n      min-width: 195px;\n      width: 195px;\n   }\n   .list-container {\n      min-width: 768px;\n      width: 768px;\n   }\n}\n@media only screen and (max-width: 480px) {\n   .info {\n      padding-left: 0px;\n      min-width: 165px;\n      width: 165px;\n   }\n   .list-container {\n      min-width: 480px;\n      width: 480px;\n   }\n}\n\ninput:disabled {\n   background: #fff;\n}\n\n.drag-over {\n   background-color: rgba(0, 188, 212, .2);\n   opacity: .5;\n}\n\n.loader-overlay {\n   background-color: #fff;\n   cursor: wait;\n   position: absolute;\n   left: 0;\n   top: 0;\n   right: 0;\n   bottom: 0;\n   z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
